import { css } from "@emotion/react";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import tokens from "~/packages/design-tokens/dist/tokens";

export const entryCss = css({
  display: "grid",
  gridTemplateColumns: "min-content auto",
  columnGap: "12px",
  alignItems: "center",
});

export const noteCss = css({
  display: "flex",
  flexDirection: "column",
  wordBreak: "break-word",
});

export const contributorsCss = css({
  display: "grid",
  gridTemplateColumns: "max-content auto",
  columnGap: "5px",
  ...fontSize(12),
  color: tokens.color.text.secondary.default.value,
});
